
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/moments",
      function () {
        return require("private-next-pages/moments.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/moments"])
      });
    }
  